/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_3HDDVbb7E",
    "aws_user_pools_web_client_id": "44741j0sbpm21p8j9di972ei49",
    "oauth": {}
};


export default awsmobile;
